<template lang="html">
  <div>
    <b-modal modal-class="modal-cv-templ" ref="modal-cv-language" size="lg" title="Idiomas" @hidden="hiddenModal()" no-close-on-esc no-close-on-backdrop centered hide-footer>

      <b-form class="px-2" @submit="onSubmit" v-if="showForm">
        <div class="row align-items-center">
          <b-form-group class="col-lg-6 custom-f-group-1 txt-sm" label="Idioma:">
            <b-form-input
              v-model="formAch.idioma"
              type="text"
              placeholder=""
              required
            ></b-form-input>
          </b-form-group>

          <div class="col-lg-6">
            <div class="row">
              <b-form-group class="col-12 custom-f-group-1 txt-sm mb-0" label="Porcentaje hablado:"></b-form-group>

              <b-form-group class="col-4 col-sm-3 col-lg-4 custom-f-group-1 txt-sm">
                <b-form-input class="text-center"
                  v-model="formAch.procentaje"
                  type="number"
                  placeholder=""
                  min="0"
                  max="100"
                  required
                ></b-form-input>
              </b-form-group>

              <div class="col-1 px-0 mt-2">
                <h6 class="f-w-600">%</h6>
              </div>
            </div>
          </div>

          <div class="col-12 mt-2">
            <b-form-checkbox
              required
              class="mb-3 custom-checkbox-s1"
              v-model="formAch.check"
              name="checkbox-1"
              value="accepted"
              :unchecked-value="null">
              Al hacer clic en la casilla de verificación, acepta nuestros <router-link to="">Términos y condiciones</router-link> y <router-link to="">Política de privacidad</router-link>
            </b-form-checkbox>

            <b-button type="submit" v-if="!editing" class="btn-HelvNeu btn-squ-cur-1 px-4 btn-send">Agregar</b-button>
            <b-button type="submit" v-else class="btn-HelvNeu btn-squ-cur-1 px-4 btn-send">Editar</b-button>
          </div>

        </div>
      </b-form>

    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editing: {
      type: Boolean,
      default: false
    },
    id: {
      default: null
    }
  },

  data(){
    return{
      showForm: false,

      formAch: {
        cvdescription: null,
        check: null,
      }
    }
  },

  methods: {
    hiddenModal(){
      this.$parent.selectedModalCV = null;
      this.$parent.editing = false;
      this.$parent.langID = null;
    },

    onSubmit(event) {
      event.preventDefault();

        axios.post(tools.url("/api/admin/updateCvIdiomas"),this.formAch).then((response)=>{
            this.$root.auth();
            this.savedmsg = 'Información guardada correctamente';
            this.$refs['modal-cv-language'].hide(); // Ocultar modal despues de guardar

            
        }).catch((error)=>{
            alert('Ocurrio un error al guardar la información');

        });
    
    },
  },

  mounted(){
    if(this.editing){
        this.formAch = this.$root.user.cv.languages[this.$parent.langID];
      console.log('Consultar la info de la BD para agregarla al "formAch"');
    }

    this.$refs['modal-cv-language'].show();

    setTimeout( ()=>{ this.showForm = true; }, 500);
  },
}
</script>
